import React from "react";
import { Routes, Route } from "react-router-dom";
import ManagerLayout from "../layouts/ManagerLayout";

import ManagerDashboard from "../pages/Manager/ManagerDashboard";
import ManagerTeam from "../pages/Manager/TeamMembers";
// Changed import path for LeaveRequests to match possible file name typo
import LeaveRequests from "../pages/Manager/LeaveRequests";
import TeamAttendance from "../pages/Manager/TeamAttendance";
import TimesheetApprovals from "../pages/Manager/TimesheetApprovals";
import Reports from "../pages/Manager/Reports";
import Announcements from "../pages/Manager/Announcements";

export default function ManagerRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ManagerLayout />}>
        <Route path="dashboard" element={<ManagerDashboard />} />
        <Route path="team" element={<ManagerTeam />} />
        <Route path="leave-requests" element={<LeaveRequests />} />
        <Route path="attendance" element={<TeamAttendance />} />
        <Route path="timesheets" element={<TimesheetApprovals />} />
        <Route path="reports" element={<Reports />} />
        <Route path="announcements" element={<Announcements />} />
      </Route>
    </Routes>
  );
}
